import { render, staticRenderFns } from "./portOfDestinationServices.vue?vue&type=template&id=5e493e1c&"
import script from "./portOfDestinationServices.vue?vue&type=script&lang=js&"
export * from "./portOfDestinationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e493e1c')) {
      api.createRecord('5e493e1c', component.options)
    } else {
      api.reload('5e493e1c', component.options)
    }
    module.hot.accept("./portOfDestinationServices.vue?vue&type=template&id=5e493e1c&", function () {
      api.rerender('5e493e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/ae/basic/portOfDestinationServices.vue"
export default component.exports